module.exports = __webpack_public_path__ + "assets/use_case.bc5421e9.svg";